import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinIssueConvertRoute: InvariantJiraRoute = {
	name: 'legacy-gin-issue-convert',
	path: '/secure/ConvertIssue(\\w*)([!%]?[\\w]*).jspa',
};
